/** @format */

import {
	CriteoViewProductsResponse,
	CriteoDigitalShelfTalker
} from '@shared/data-access/interfaces';

export const EMPTY_CRITEO_DIGITAL_SHELF_TALKER: CriteoDigitalShelfTalker = {
	OnClickBeacon: '',
	OnLoadBeacon: '',
	OnViewBeacon: '',
	OnFileClickBeacon: '',
	OnBundleBasketChangeBeacon: '',
	LineItemID: '',
	rendering: {
		desktop_background_image: '',
		desktop_background_image_alt_text: '',
		mobile_background_image: '',
		mobile_background_image_alt_text: '',
		background_color: '',
		redirect_url: '',
		redirect_target: '',
		redirect_url_app: '',
		footer_text: '',
		footer_text_color: '',
		footer_background_color: ''
	}
};

/**
 * Used to initialize or reset the setCriteoProducts state to allow the
 * plp product list effect to run without making a call to Criteo.
 */
export const EMPTY_CRITEO_VIEW_PRODUCTS_RESPONSE: CriteoViewProductsResponse = {
	OnLoadBeacon: '',
	placements: [
		{
			carousel: [
				{
					OnClickBeacon: '',
					OnLoadBeacon: '',
					OnViewBeacon: '',
					format: '',
					rendering: '',
					products: []
				}
			]
		},
		{
			inGrid: [
				{
					OnClickBeacon: '',
					OnLoadBeacon: '',
					OnViewBeacon: '',
					format: '',
					rendering: '',
					products: []
				}
			]
		},
		{
			digitalShelfTalker: { ...EMPTY_CRITEO_DIGITAL_SHELF_TALKER }
		}
	]
};

export const CRITEO_PINNED_CONTENT_REQUIRED_ATTRIBUTES = [
	'desktop_background_image_alt_text',
	'redirect_url',
	'footer_text',
	'footer_text_color',
	'desktop_background_image'
];

export const CRITEO_DIGITAL_SHELF_TALKER_POSITION = 5;
